import { autoserialize, autoserializeAs } from 'cerialize';

import { BaseDTO, IBaseDTO } from './base-dto';
import { IItemMeta, ItemMeta } from './item-meta';
import { ISpecification, Specification } from './specification';

export class Item extends BaseDTO implements IItem {
  @autoserialize id?: string;
  @autoserializeAs('created_at') createdAt?: string;
  @autoserializeAs('discarded_at') discardedAt?: string | null;
  @autoserialize approved?: boolean;
  @autoserialize override name: string;
  @autoserialize description?: string;
  @autoserialize description_preview: string;
  @autoserializeAs(Specification, 'specification') specification: Specification;
  @autoserialize width?: number;
  @autoserialize height?: number;
  @autoserialize depth?: number;
  @autoserialize volume?: number;
  @autoserialize price?: number;
  @autoserialize sell_rate?: number;
  @autoserialize icon_url?: string;
  @autoserializeAs(ItemMeta, 'meta') meta?: ItemMeta | null;

  constructor(payload?: IItem) {
    super(payload);
    this.id = payload?.id?.toString();
    this.specification = new Specification(payload?.specification);
    this.createdAt = payload?.createdAt;
    this.discardedAt = payload?.discardedAt;
    this.approved = payload?.approved;
    this.name = payload?.name;
    this.description = payload?.description;
    this.description_preview = payload?.description_preview;
    this.icon_url = payload?.icon_url;
    this.width = payload?.width || 0;
    this.height = payload?.height || 0;
    this.depth = payload?.depth || 0;
    this.volume = payload?.volume || 0;
    this.price = payload?.price;
    this.sell_rate = payload?.sell_rate;
    this.meta = new ItemMeta(payload?.meta);
  }

  public static OnSerialized(instance: Item, json: any): void {
    json.price = json.price !== null ? this.formatPrice(json.price * 100) : null;
    if (json.sell_rate) json.sell_rate = json.sell_rate !== null ? json.sell_rate / 100 : null;
  }

  public static OnDeserialized(instance: Item): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    instance.price = instance.price !== null ? this.formatPrice(instance.price / 100) : null;
    instance.sell_rate = instance.sell_rate !== null ? this.formatPrice(instance.sell_rate * 100) : null;
  }

  public static formatPrice(price: number): number {
    return Math.round(price * 100) / 100;
  }
}

export interface IItem extends IBaseDTO {
  id?: string;
  createdAt?: string;
  discardedAt?: string;
  approved?: boolean;
  name: string;
  description?: string;
  description_preview: string;
  specification: ISpecification;
  width?: number;
  height?: number;
  depth?: number;
  volume?: number;
  meta?: IItemMeta | null;
  price?: number;
  sell_rate?: number;
  icon_url?: string;
}
